/* eslint-disable eqeqeq */
<template>
  <div class="organization-tree-container">
    <el-input style="margin-bottom:10px"
              placeholder="搜索分类"
              prefix-icon="el-icon-search"
              v-model="filterText"></el-input>
    <p class="tips">温馨提示：树形可通过鼠标右键维护</p>
    <div class="tree">
      <el-tree class="treeShow"
               :data="treeData"
               :props="defaultProps"
               node-key="id"
               ref="baseTree"
               :highlight-current="true"
               :expand-on-click-node="true"
               :filter-node-method="filterNode"
               @node-contextmenu="rihgtClick"
               @node-click="getId"
               :default-expanded-keys="selectedNodeList"
               draggable
               :auto-expand-parent="false"
               :accordion="false">
        <span class="slot-t-node"
              slot-scope="{ node, data }">
          <!-- <span v-show="!node.isEdit"> -->
          <span>
            <!-- <span v-show="data.children && data.children.length >= 1"> -->
            <span v-show="data.children && data.children.length >= 1">
              <!-- <i :class="{'el-icon-time':node.level<=1,'el-icon-bell':node.level>1&&node.level<=2,'el-icon-service':node.level>2}" /> -->
              <!-- <i :class="{ 'el-icon-plus':!node.expanded,'el-icon-minus':node.expanded}" /> -->
              <slot name="ruleIcon"
                    v-if="data.resolve_type!=='2'">
              </slot>
              <slot name="flowIcon"
                    v-if="data.resolve_type==='2'">
              </slot>
              <span :class="[data.id >= maxexpandId ? 'slot-t-node--label' : '']"
                    id="show-ellipsis"
                    :title="data.name">{{ data.name || data.system_name }}</span>
            </span>
            <!-- 当树形节点不存在子节点时，设置单独的图标 -->
            <!-- <span v-show="!data.children|| data.children.length == 0"> -->
            <span v-show="!data.children|| data.children.length == 0">
              <!-- <i class="el-icon-document"></i> -->
              <slot name="ruleIcon"
                    v-if="data.resolve_type!=='2'">
              </slot>
              <slot name="flowIcon"
                    v-if="data.resolve_type==='2'">
              </slot>
              <span :class="[data.id >= maxexpandId ? 'slot-t-node--label' : '']"
                    id="show-ellipsis"
                    :title="data.name">{{data.name || data.system_name }}</span>
            </span>
          </span>
        </span>
      </el-tree>
    </div>
    <slot name="menu"
          :menuVisible="menuVisible"
          :data="DATA"></slot>

  </div>
</template>
<script>

import { OBSManageApi } from '@/services/orgainzeManage'

export default {
  name: 'leftTree',

  data () {
    var checkName = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入分类名称'))
      } else if ((/^[\s]|[ ]$/gi).test(value)) {
        callback(new Error('请输入正确的分类名称'))
      } else {
        callback()
      }
    }
    var checkNum = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入分类编号'))
      } else if ((/^[\s]|[ ]$/gi).test(value)) {
        callback(new Error('请输入正确的分类编号'))
      } else {
        callback()
      }
    }
    var checkEditName = (rule, value, callback) => {
      callback()
    }
    var checkEditNum = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入分类编号'))
      } else if ((/^[\s]|[ ]$/gi).test(value)) {
        callback(new Error('请输入正确的分类编号'))
      } else {
        callback()
      }
    }
    return {
      judge: '', // 类型判断（新增/修改子单位）
      judgeDepart: '', // 类型判断(新增/修改部门)
      judgePost: '', // 类型判断(新增/修改岗位)
      info: this.messageinfo,
      // 树形数据
      treeData: [],
      type: this.treetype,
      filterText: '',
      addSonUnitDialog: false,

      DATA: {

      },
      NODE: {

      },
      maxexpandId: this.maxid, // 新增节点开始id
      non_maxexpandId: this.maxid, // 新增节点开始id(不更改)
      // maxexpandId: 95, //新增节点开始id
      // non_maxexpandId: 95, //新增节点开始id(不更改)
      isLoadingTree: true, // 是否加载节点树
      //   setTree:api.treelist,//节点树数据
      level: 0, // 右键点击节点的等级
      childNodes: [],
      defaultProps: {
        children: 'children',
        label: 'name'
      },
      menuVisible: false,
      objectID: null,

      // 部门类型列表
      depList: [],

      // 分类（添加分类的弹窗表单）
      addNodeForm: {
        name: '',
        num: ''
      },
      addNodeRules: {
        name: [
          { validator: checkName, trigger: 'blur' }
        ],
        num: [
          { validator: checkNum, trigger: 'blur' }
        ]
      },
      // 修改分类的弹窗表单
      editNodeForm: {
        name: '',
        num: ''
      },
      editNodeRules: {
        name: [
          { validator: checkEditName, trigger: 'blur' }
        ],
        num: [
          { validator: checkEditNum, trigger: 'blur' }
        ]
      },
      nodeData: {},
      nodeLevel: 0,
      editNodeData: {},
      editNodeLevel: 0,
      orgainzationTreeParam: {

      },
      orgainzationTreeData: [],

      // 选中的节点列表，用于刷新后展开到指定位置
      selectedNodeList: [],
      // 单位类型标准码列表
      orgTypeCodeList: []
    }
  },
  props: {
    selectedNode: Object,
    assignedNode: Object,
    assignedTemplateNode: Object,
    rightMenu: {
      type: Boolean,
      default: true
    },
    companyId: String,
    data: Array
  },
  watch: {
    filterText (val) {
      this.$refs.baseTree.filter(val)
    },
    data: {
      handler (newval, oldval) {
        this.treeData = newval
        console.log(this.treeData, 'watch ')
      },
      deep: true
    }
  },
  computed: {
    orgainzationTree () {
      let store = this.$store.state.orgainzationTree
      // let storage = JSON.parse(window.localStorage.getItem('orgainzationTree')) || []
      // let treeData = store.length > 0 ? store : storage
      return store || []
    }
  },
  methods: {

    // 节点点击事件获取id
    getId (obj, node, self) {
      obj.level = node.level
      this.menuVisible = false

      this.$emit('update:selectedNode', JSON.parse(JSON.stringify(obj)))
      if ((node.expanded || node.childNodes.length === 0) && obj.id) {
        this.addNodeList(obj.id)
      } else {
        this.removeNodeList(obj.id)
      }
    },
    // 当前节点是展开操作时,将当前节点的object_id添加到selectedNodeList中，为了刷新数据后能够展开到指定位置
    addNodeList (id) {
      let index = this.selectedNodeList.indexOf(id)
      if (index < 0) {
        this.selectedNodeList.push(id)
      }
    },
    // 当前节点是收起操作时，将当前节点的object_id从selectedNodeList中移除
    removeNodeList (id) {
      let index = this.selectedNodeList.indexOf(id)
      if (index >= 0) {
        this.selectedNodeList.splice(index, 1)
      }
    },
    // 对树节点进行筛选时执行的方法，返回 true 表示这个节点可以显示，返回 false 则表示这个节点会被隐藏
    filterNode (value, data) {
      console.log('data_csy=', data, value)
      // if (!value) return true
      // return data.name.indexOf(value) !== -1
      if (!value) return true
      return data.name.indexOf(value) !== -1
    },

    NodeEdit (n, d) {
      // 编辑节点
      if (d.code_type) { // 判断修改的是标准码管理页面的树形还是参数管理的树形
        this.editNodeForm.num = d.code_type
      } else {
        this.editNodeForm.num = d.para_type
      }
      this.editNodeForm.name = d.name
      this.editNodeData = d
      this.editNodeLevel = n.level
      this.editNodeDialog = true
    },
    NodeDel (n, d) {
      // 删除节点
      if (d.children_list && d.children_list.length !== 0) {
        this.$message.error('此节点有子级，不可删除！')
        return false
      } else {
        this.deleteParam = {}
        // 新增节点可直接删除，已存在的节点要二次确认
        // 删除操作
        // let DelFun = () => {
        //   this.$emit('deleteTreeNode', d.id)
        // }
        // 二次确认
        let ConfirmFun = () => {
          this.$confirm('是否删除此节点？', '提示', {
            confirmButtonText: '确认',
            cancelButtonText: '取消',
            type: 'warning'
          })
            .then(() => {
              if (d.node_type === '1') {
                this.deleteParam.company_id = d.company_id
                this.deleteParam.org_id = d.id
                this.deleteParam.org_no = d.no
                this.deleteOrg()
              } else if (d.node_type === '2') {
                this.deleteParam.company_id = d.company_id
                this.deleteParam.dept_id = d.id
                this.deleteParam.dept_no = d.no
                this.deleteDept()
              } else {
                this.deleteParam.job_id = d.id
                this.deleteJob()
              }
            })
            .catch(() => { })
        }
        // 判断是否是新增节点
        // d.id > this.non_maxexpandId ? DelFun() : ConfirmFun();
        ConfirmFun()
      }
    },

    NodeAdd (n, d) {
      // 新增节点
      // console.log(n, d);
      // 判断层级
      if (n.level >= 4) {
        this.$message.error('最多只支持三级！')
        return false
      }
      this.addNodeDialog = true
      this.nodeLevel = n.level
      this.nodeData = d
      // 同时展开节点
      if (!n.expanded) {
        n.expanded = true
      }
    },

    // 获取单位类型列表
    getDepList () {
      OBSManageApi.getDepList({
        params: {
          code_type: 'deptType',
          is_page: '1'
        }
      }).then(res => {
        console.log('depList', res)
        this.depList = res.data.list
      })
    },

    // 右键点击事件
    rihgtClick (event, object, value, element) {
      // this.level = value.level
      // this.childNodes = value.childNodes
      object.level = value.level
      this.$emit('getTreeNodeValue', value)
      if (this.rightMenu) {
        // if (this.objectID !== object.remark) {
        //   this.objectID = object.remark;
        //   this.menuVisible = true;
        //   this.DATA = object;
        //   this.NODE = value;
        // } else {
        //   this.menuVisible = !this.menuVisible;
        // }
        // console.log(object, value, 'right click')
        this.DATA = object
        this.NODE = value
        this.menuVisible = !this.menuVisible
        document.addEventListener('click', e => {
          this.menuVisible = false
        })
        let menu = document.querySelector('#rightClickMenu')
        let content = document.querySelector('.content-container')
        /* 菜单定位基于鼠标点击位置 */
        menu.style.left = event.clientX + 20 - 200 + 'px'
        menu.style.top = event.clientY - 100 + content.scrollTop + 'px'
        // console.log(event.clientY, content.scrollTop)
        menu.style.position = 'absolute' // 为新创建的DIV指定绝对定位
        menu.style.width = 160 + 'px'
      }
    }

  },
  created () {
    this.selectedNodeList = []
  },
  mounted () {
  },
  updated () {

  }
}
</script>
<style lang="scss" scoped>
/* 去掉默认的树形图标 */
/* .treeShow /deep/ .el-tree-node__content>.el-tree-node__expand-icon {
  display: none;
} */
#save-style {

  color: white;
}
#back-style {

}
#show-ellipsis {
  //display: block;
  width: 100%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.popover-new {
  /* position: absolute!important;
    right: 0;
    bottom: 0; */
}
/*顶部按钮*/
.slot-tree .slot-t-top {
  margin-bottom: 15px;
}
.slot-tree .slot-t-node span {
  display: inline-block;
}
/*节点*/
.slot-tree .slot-t-node--label {
  font-weight: 600;
}
/*输入框*/
.slot-tree .slot-t-input .el-input__inner {
  height: 26px;
  line-height: 26px;
}
/*按钮列表*/
.slot-tree .slot-t-node .slot-t-icons {
  display: none;
  margin-left: 10px;
}
.slot-tree .slot-t-icons .el-button + .el-button {
  margin-left: 6px;
}
.slot-tree .el-tree-node__content:hover .slot-t-icons {
  display: inline-block;
}

/*************************标签鼠标右击页面样式******************************/
.el-menu-vertical {
  border: 3px solid rgb(84, 92, 100);

  border-radius: 10px;
  z-index: 100;
  .menuItem {
    height: 40px;
    line-height: 40px;
    /* background-color: #545c64; */
    background-color: #545c64;
    font-size: 14px;
    &:hover {
      background-color: #409eff;
    }
    i {
      color: #fff;
    }
  }
}

.add_tips /deep/ .el-form-item__label {
  /* padding-left: 28px; */
}
.organization-tree-container {
  margin-top: 20px;
  // width: 240px;
  height: 100%;
  background-color: #fff;
  .tips {
    color: #9e9e9e;
    margin-bottom: 10px;
    text-align: center;
  }
  .tree{
    height:calc(100% - 80px);
    overflow-y:auto;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/BaseTree/BaseTree.vue